export interface HasGotMinimumDecisions {
  county: boolean;
  institution: boolean;
}

export enum TabKey {
  BasicInfo = "basicInfo",
  InstitutionInfo = "institutionInfo",
  InitialQuestionnaireInfo = "initialQuestionnaireInfo",
  DocumentInfo = "documentInfo",
  InstitutionCommitteeDecisionInfo = "institutionCommitteeDecisionInfo",
  CountyCommitteeDecisionInfo = "countyCommitteeDecisionInfo",
  MedicalExaminationInfo = "medicalExaminationInfo",
  MzomAppealInfo = "mzomAppealInfo",
}

export interface PageState {
  tabState: TabKey;
}

export type PendingAction = "generateDecisionProposal" | "approve" | null;

export interface RemarksRedirectModalProps {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  pendingAction: PendingAction;
}
